export interface User {
	id: string;
	name: string;
	username: string;
	role: string;
	entitlements: string[];
	phoneNumber?: string;
	email?: string;
	blocked?: boolean;
}

export enum Operation {
	PATCH = 'PATCH',
}

export type UserActionData = Partial<User> & { id: string };

export interface UserAction {
	operation: Operation;
	data: UserActionData;
}

export interface UserOperationResult {
	data: { status: number; user: User };
}

export interface CreateUserResponse {
	created_at: string;
	email: string;
}

export const defaultUser: User = {
	entitlements: [],
	id: '',
	name: '',
	role: '',
	username: '',
	email: '',
	phoneNumber: '',
};

export const defaultUserById = {
	initialized: false,
	user: {
		entitlements: [],
		id: '',
		name: '',
		role: '',
		username: '',
		email: '',
		phoneNumber: '',
	},
};

export interface BulkUpdateSingleSubscriptionUsersRequest {
	removeUserOperations: UserAction[];
	addUserOperations: UserAction[];
}
